module.exports = __webpack_public_path__ + "img/sign-out.ae71f457.svg";